/**
 * @type {Record<string, (state: typeof import('./state').default, getters: any, rootState: any, rootGetters: any) => any>}
 */
export default {
  isLoading(state) {
    return state.isLoading
  },
  isListOpen(state) {
    return state.isListOpen
  },

  // For display in notification list in desc order
  notifications(state) {
    return state.notifications.toSorted((a, b) => b.notification_id - a.notification_id)
  },
  nUnread(state) {
    return state.nUnread
  },
  mode(state) {
    return state.mode
  },
  hasMore(state) {
    return state.hasMore
  },
  cursor(state) {
    return Math.min(
      Math.min.apply(null, state.notifications.map(notification => notification.notification_id)),
      Number.MAX_SAFE_INTEGER
    )
  },
}
